// extracted by mini-css-extract-plugin
export default {"bottomMenu":"Bottombar_bottomMenu__vPwvK","menu":"Bottombar_menu__wO7zK","icon":"Bottombar_icon__mH9dq"};